// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import styled from 'styled-components';
import Player from '../Player';
import Sidebar from './components/Sidebar';

export const S = {
  Container: styled.div`
    height: calc(100vh - 70px);
    width: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    flex-grow: 1;
    overflow: hidden;
  `,
  VideoContainer: styled.div`
    align-self: stretch;
    flex: 1;
  `,
  Player: styled(Player)``,
  Sidebar: styled(Sidebar)`
    flex-shrink: 0;
  `,
};
